import { useEffect, useRef } from 'react';
import { useMessageHub } from '../../../shared/messageHub/lib/useMessageHub';

interface MessageHubProviderProps {
  children: React.ReactNode;
}

export const MessageHubProvider: React.FC<MessageHubProviderProps> = ({
  children,
}) => {
  const { disconnect, isConnected, connect } = useMessageHub();
  const effectRan = useRef(false);

  useEffect(() => {
    if (effectRan.current) return;
    effectRan.current = true;
    if (!isConnected) {
      connect();
    }
    return () => {
      if (effectRan.current) return;
      disconnect();
      effectRan.current = false;
    };
  }, []);

  return <>{children}</>;
};
